import { useEffect } from "react";

import { APP_CONSTANTS } from "../config/appConstants";

const useTitle = (title) => {
	useEffect(() => {
		const prevTitle = document.title;
		document.title = APP_CONSTANTS.PORTAL_NAME + " - " + title;

		return () => {
			document.title = prevTitle;
		};
	}, [title]);
};
export default useTitle;
